import { Injectable } from '@angular/core';

/** Motsvarar din C#-enum */
export enum DiscountType {
  ServiceFee = 0,
  InvoiceFee = 1
}

export enum DiscountCategory {
  Percentage = 0,
  Fixed = 1
}

export interface IDiscountCode {
  Id: number;
  Code: string;
  
  /** För procentuell rabatt (decimal? i C#). */
  DiscountPercentage?: number;

  /** För fast belopp (decimal? i C#). */
  FixedDiscountAmount?: number;

  /** För att ange om avgiften är gratis. */
  IsFree: boolean;

  /** Motsvarar public DiscountType Type { get; set; } */
  Type: number;

  Category: number;

  /** Om rabatt kräver kod. */
  RequiresCode: boolean;

  /** Datum i C# är DateTime?. Ofta returneras det som en sträng i JSON, 
      men du kan också välja att hantera dem som Date. */
  IsTimeLimited: boolean;
  ValidFrom?: string | Date;
  ValidUntil?: string | Date;

  /** Max antal användningar (int?). */
  MaxUsage?: number;

  /** Hur många gånger rabatten har använts. */
  UsedCount: number;

  /** Gäller för ett visst organisationsnummer. */
  ApplicableToOrgNumber?: string;

  /** Gäller från ett visst organisationsnummer. */
  ApplicableFromOrgNumber?: string;

  /** Gäller för en viss användare. */
  ApplicableUserPersonalNumber?: string;

  /** Om rabatten gäller alla. */
  IsGlobal: boolean;

  /** Om rabatten automatiskt aktiveras vid fakturaskapande. */
  IsAutoApplied: boolean;

  /** Gäller de första fakturorna. */
  AppliesToNewRegistrations: boolean;

  /** Gäller en viss tidsperiod. */
  AppliesToNewRegistrationsDays: number;

  AllowCombinationWithOtherType: boolean;

  Active: boolean;
}
